export const ArrowDown = '/icons/arrow-down.svg'
export const ArrowLeft = '/icons/arrow-left.svg'
export const ArrowRight = '/icons/arrow-right.svg'
export const ArrowUp = '/icons/arrow-up.svg'
export const ChevronDown = '/icons/chevron-down.svg'
export const ChevronUp = '/icons/chevron-up.svg'
export const Close = '/icons/close.svg'
export const DebugContinue = '/icons/debug-continue.svg'
export const DebugPause = '/icons/debug-pause.svg'
export const DebugStepInto = '/icons/debug-step-into.svg'
export const DebugStepOut = '/icons/debug-step-out.svg'
export const DebugStepOver = '/icons/debug-step-over.svg'
export const ExtensionDefaultIcon = '/icons/extensionDefaultIcon.png'
export const LinkExternal = '/icons/link-external.svg'
export const NextMatch = '/icons/arrow-down.svg'
export const PreviousMatch = '/icons/arrow-up.svg'
export const Refresh = '/icons/refresh.svg'
export const TriangleDown = '/icons/triangle-down.svg'
export const TriangleRight = '/icons/triangle-right.svg'
export const ZoomIn = '/icons/zoom-in.svg'
export const ZoomOut = '/icons/zoom-out.svg'
